module.exports = __webpack_public_path__ + "static/pipedrive-97983c54a972c06da06ce598d3ac52a7.png";